import { Skeleton } from "@/components/ui/skeleton";

export const BlogCardSkeleton = () => {
  return (
    <div className="flex flex-col space-y-3">
      {/* Image Skeleton */}
      <Skeleton className="h-[200px] w-full rounded-xl" />
      
      {/* Title & Excerpt Skeleton */}
      <div className="space-y-2 p-2">
        <Skeleton className="h-6 w-3/4" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-5/6" />
      </div>

      {/* Tags Skeleton */}
      <div className="flex gap-2 p-2">
        <Skeleton className="h-6 w-16 rounded-full" />
        <Skeleton className="h-6 w-16 rounded-full" />
      </div>

      {/* Footer Skeleton */}
      <div className="flex justify-between items-center p-2">
        <Skeleton className="h-4 w-20" />
        <Skeleton className="h-8 w-24 rounded-md" />
      </div>
    </div>
  );
};